export class Resource {
  id: number;
  version: number;
  ativo: boolean;
  selecionado = false;
  acoes: string[] = [];
}
